import { render, staticRenderFns } from "./letterReservation.vue?vue&type=template&id=3dbd6212&scoped=true"
import script from "./letterReservation.vue?vue&type=script&lang=js"
export * from "./letterReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd6212",
  null
  
)

export default component.exports